import { fetchWithTrace } from '../fetchWithTrace';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

async function postJSON(path, body) {
    const token = localStorage.getItem('token');
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

    const { data } = await fetchWithTrace(`${API_URL}${path}`, {
        method: 'POST',
        credentials: 'include',
        headers,
        body: body ?? {}
    });
    return data;
}

export async function generateVideoFromPrompt(scenePrompt, imageUrl, options = {}) { const { url } = await postJSON('/api/videos/generateVideoFromPrompt', { scenePrompt, imageUrl, options }); return url; }
export async function generateVideoFromPrompt_todo(scenePrompt, imageUrl, options = {}) { const { url } = await postJSON('/api/videos/generateVideoFromPrompt_todo', { scenePrompt, imageUrl, options }); return url; }
export async function generateVideoFromPromptX(scenePrompt, imageUrl, options = {}) { const { url } = await postJSON('/api/videos/generateVideoFromPromptX', { scenePrompt, imageUrl, options }); return url; }
export async function generateVideoFromPrompt2(prompt) { const { url } = await postJSON('/api/videos/generateVideoFromPrompt2', { prompt }); return url; }


export async function createVideoJob(scenePrompt, imageUrl, options = {}, model = 'veo') {
    const r = await postJSON('/api/videos/jobs', { scenePrompt, imageUrl, options, model });
    return r.jobId;
}

export async function createAdvancedVideoJob(scenePrompt, referenceImages, options = {}, model = 'veo') {
    const finalOptions = { ...options };
    if (Array.isArray(referenceImages) && referenceImages.length > 0) {
        finalOptions.referenceImages = referenceImages;
    }
    // Advanced mode uses referenceImages strategy rather than legacy posterUrl
    const r = await postJSON('/api/videos/jobs', {
        scenePrompt,
        imageUrl: null,
        options: finalOptions,
        model
    });
    return r.jobId;
}

export const DEFAULT_CINEMATIC_CONTEXT = "True cinematic drama — stylized but grounded. Think Deakins/Fraser: single motivated key, deep negative fill, bold contrast ratio (~8:1) with smooth roll-off. Emulate 35mm/IMAX film (Kodak 5219, push-1) with fine organic grain and gentle halation. Underexpose ~2/3 stop for denser blacks; preserve highlight detail. Maintain a consistent LUT and lighting direction across shots. Use warm keys (fire/candle/brass) against cool steel-blue shadows for color separation. Add subtle atmosphere: light haze, drifting ember/dust particles, soft volumetrics. Avoid flat digital lighting, over-clean skin, jittery motion, banding, or exposure pumping. Generate ONE 8s clip per shot with a natural start and soft settle end (no loops, no jump-cuts).";

export async function generateSceneShotVideos({ projectId, scene, characterBible, options = {}, model = 'veo' }) {
    const context = DEFAULT_CINEMATIC_CONTEXT;
    return postJSON('/api/videos/generateSceneShotVideos', { projectId, context, scene, characterBible, options, model });
}

export async function generateShotVideo({ projectId, scene, beat, shot, characterBible, options = {}, model = 'veo', promptOverride, context }) {
    return postJSON('/api/videos/generateShotVideo', { projectId, scene, beat, shot, characterBible, options, model, promptOverride, context });
}

export async function getVideoJob(jobId) {
    await new Promise(r => setTimeout(r, 2000));
    const token = localStorage.getItem('token');
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    const { data } = await fetchWithTrace(`${API_URL}/api/videos/jobs/${jobId}`, {
        credentials: 'include',
        headers
    });
    return data;
}


export async function submitTranscoderMerge(videoUrls, outputName, geometry = { width: 1920, height: 1080, fps: 24 }) {
    return postJSON('/api/videos/transcoder-merge', {
        videoUrls,
        outputName,
        geometry
    });
}

export async function submitTranscoderSmooth(videoUrl, outputName, geometry = { width: 1920, height: 1080 }) {
    return postJSON('/api/videos/transcoder-smooth', {
        videoUrl,
        outputName,
        geometry
    });
}


export async function getTranscoderJob(jobId) {
    await new Promise(r => setTimeout(r, 2000));
    const token = localStorage.getItem('token');
    const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
    const { data } = await fetchWithTrace(`${API_URL}/api/videos/transcoder-jobs/${jobId}`, {
        credentials: 'include',
        headers
    });
    return data;
}